export const Roles = {
	Compliance: 'Compliance',
	Lender: 'Lender',
	Borrower: 'Borrower',
	SuperAdmin: 'SuperAdmin',
	AccountManager: 'AccountManager',
	SEOManager: 'SEOManager',
	Credit: 'Credit',
};
